// biome-ignore lint/suspicious/noExplicitAny: any
export const noop = (..._args: any[]) => {
  //
};
